import { TYPED_ENV } from "@/utils/env";

export const DEFAULT_ERROR_MESSAGE = "Required";
export const FIRST_NAME_ERROR_MESSAGE = "Enter valid first name";
export const SECOND_NAME_ERROR_MESSAGE = "Enter valid last name";
export const NAME_ERROR_MESSAGE = "Enter valid name";
export const EMAIL_ERROR_MESSAGE = "Enter valid email";
export const PHONE_ERROR_MESSAGE =
  "Invalid phone number format. It should be in the format (222) 345-6789";
export const NUMBER_OF_ANSWERS = 5;
export const VERIFY_CODE_ERROR_MESSAGE =
  "Invalid code. It should be in the format of XX-XX ";
export const ZIP_CODE_ERROR_MESSAGE = "Invalid US zip code format";

export const FRONT_TERMS_LINKS = {
  TEXT_MESSAGE_TERMS: `${TYPED_ENV.VITE_FRONT_BASE_URL}/text-message-terms`,
  TERMS: `${TYPED_ENV.VITE_FRONT_BASE_URL}/terms`,
  PRIVACY: `${TYPED_ENV.VITE_FRONT_BASE_URL}/privacy`,
};
